import { useAppDispatch, useAppSelector } from "@/Hook/hooks";
import { changeObjectActivity, copyDocumentByPrid, deleteDocument, getDocumentByPrid, getScreenConfig, removeUserDocumentHelp, saveUserDocumentHelpFilter, setDocumentHelpView, setViewDefaultUserDocumentHelp } from "@/Redux/Ducks/entryFormSlice";
import { closeHelp, EHelpOpenFor, EHelpType, IHelpHeader, loadHelpData, setHelpDetailData } from "@/Redux/Ducks/helpSlice";
import { setUserFavorite } from "@/Redux/Ducks/homeSlice";
import { loaderText, toggleLoader } from "@/Redux/Ducks/loaderSlice";
import { setTabMessage } from "@/Redux/Ducks/messageSlice";
import { getReportConfig } from "@/Redux/Ducks/reportExplorerSlice";
import { closeTab } from "@/Redux/Ducks/tabSlice";
import { requestGetScreenUploadingTemplate, requestUploadScreenDataFromTemplate } from "@/Redux/Sagas/Requests/entryForm";
import { TableHelpUI, THelpTableHelpHandle } from "@/UI/BaseComponents/Help/tableHelpUI";
import { ArrayKeyValueObject, EActivity, IDimension, IDocumentHelpView, IOtherState, ISaveParams, KeyValueObject } from "@/UI/Interfaces/IBaseUI";
import { IFieldConfig } from "@/UI/Interfaces/IFieldConfig";
import * as wijmo from "@grapecity/wijmo";
import * as wjCore from "@grapecity/wijmo";
import BaseMethods from "AlignBaseUI/BaseMethods";
import { ControlTranslation, Icon, Modal, Workspace } from "AlignComponents";
import classNames from "classnames";
import * as H from "history";
import md5 from "js-md5";
import { useEffect, useRef, useState } from "react";
import { Button, ButtonGroup, Dropdown, DropdownButton, Form, FormControl, OverlayTrigger, Tooltip } from "react-bootstrap";
import { AiFillStar, AiOutlineStar } from "react-icons/ai";
import { BiSelectMultiple } from "react-icons/bi";
import { BsThreeDotsVertical } from "react-icons/bs";
import { FaRegCheckCircle } from "react-icons/fa";
import { FiCopy, FiDownload, FiFilter, FiUpload } from "react-icons/fi";
import { GrInfo } from "react-icons/gr";
import { HiOutlinePrinter } from "react-icons/hi";
import { IoMdAdd, IoMdClose, IoMdRefresh, IoMdSave, IoMdTrash } from "react-icons/io";
import { MdOutlineCancel } from "react-icons/md";
import XLSX from "xlsx-js-style";
import { openConfirmation, openErrorConfirmation } from "../Alert";
import getControlTranslationText from "../ControlTranslationText";


interface IProps {
  history: H.History
}

const DocumentHelpUI = ({ history }: IProps) => {
  const dispatch = useAppDispatch();

  const [filterModalOpen, toggleFilterModalOpen] = useState<boolean>(false);
  const [importModalOpen, toggleImportModalOpen] = useState<boolean>(false);
  const [importHeaderTemplate, setImportHeaderTemplate] = useState<(IHelpHeader & { mandatory: boolean })[]>([]);
  const [importTemplate, setImportTemplate] = useState<{
    allUploaded: boolean,
    header: typeof importHeaderTemplate,
    model: ArrayKeyValueObject,
    modelInGroup: ArrayKeyValueObject,
    dimensionSet: IDimension[]
  }>({ allUploaded: false, header: [], model: [], modelInGroup: [], dimensionSet: [] });

  const importFileRef = useRef<any>();
  const rowMenu = useRef<HTMLDivElement>(null);
  const gridRef = useRef<THelpTableHelpHandle>(null);
  const gridMenuOptionRef = useRef<any>();
  const settingSaveTimeout = useRef<any>(null);
  const [showGrid, setShowGrid] = useState<boolean>(false);
  const [showMenu, setShowMenu] = useState<boolean>(false);
  const [deleteBtn, showDeleteBtn] = useState<boolean>(false);
  const [activeRow, setActiveRow] = useState<any>(null);

  const [gridViewModelValue, setGridViewModalValues] = useState<{
    filterName: string,
    isDefault: boolean
  }>({
    filterName: "",
    isDefault: false
  });
  const [objects, setObjects] = useState<Array<{ header: string, columnId: string, selected: boolean }>>([]);
  const [columnVisibilityModalState, toggleModalColumnVisibility] = useState<boolean>(false);

  const helpConfig = useAppSelector((x) => x.Help[x.EntryForm.activeObjectId]?.loadedHelp);
  const activeTabObject = useAppSelector((x) => x.Tab.tabs.find(y => y.tabKey == x.Tab.activeTabKey));
  const activeObjectData = useAppSelector((x) => {
    const activeObj = x.EntryForm.objects[x.EntryForm.activeObjectId];
    return {
      objectId: activeObj?.objectId || "",
      dockey: activeObj?.ScreenConfig?.TcodeConfiguration?.dockey || "",
      processcode: activeObj?.ScreenConfig?.TcodeConfiguration?.processcode || "",
      processcodestxt: activeObj?.ScreenConfig?.TcodeConfiguration?.processcodestxt || "",
      applicationobjecttype: activeObj?.ScreenConfig?.TcodeConfiguration?.applicationobjecttype || "",
      hasCreateApproval: activeObj?.ScreenConfig?.TcodeConfiguration?.hasCreateApproval || false,
      hasChangeApproval: activeObj?.ScreenConfig?.TcodeConfiguration?.hasChangeApproval || false,
      hasDeleteApproval: activeObj?.ScreenConfig?.TcodeConfiguration?.hasDeleteApproval || false,
      hasReverseApproval: activeObj?.ScreenConfig?.TcodeConfiguration?.hasReverseApproval || false,
      isdeleteRights: activeObj?.ScreenConfig?.TcodeConfiguration?.isdelete || false,
      iscreateRights: activeObj?.ScreenConfig?.TcodeConfiguration?.iscreate || false,
      clonerequired: activeObj?.ScreenConfig?.TcodeConfiguration?.clonerequired || false,
      savemode: activeObj?.ScreenConfig?.TcodeConfiguration?.savemode || "",
      isfavorite: activeObj?.ScreenConfig?.TcodeConfiguration?.isfavorite || false,
      appliedDocumentHelpView: activeObj?.otherState?.appliedDocumentHelpView || {},
      allowimport: activeObj?.ScreenConfig?.TcodeConfiguration?.allowimport || false,
      importlabelstxt: activeObj?.ScreenConfig?.TcodeConfiguration?.importlabelstxt || "",
      userDocumentHelpFilter: activeObj?.otherState?.userDocumentHelpFilter || [],
      ProcessReports: activeObj?.ScreenConfig?.ProcessReports || [],
      DocumentationUrls: activeObj?.ScreenConfig?.TcodeConfiguration.DocumentationUrls || [],
      GridConfig: activeObj?.ScreenConfig?.Grids?.GridConfig || {},
      FieldConfig: activeObj?.ScreenConfig?.Fields?.FieldConfig || [],
    }
  });
  const selectedLegalEntity = useAppSelector(x => x.User.selectedLegalEntity);
  const [objectSearch, setObjectSearch] = useState<string>("");

  const filterObjects = objects.filter(x => {
    const searchSplit = objectSearch.split(" ");
    if (!objectSearch || searchSplit.filter(y => x.header.toLowerCase().includes(y.toLowerCase())).length == searchSplit.length)
      return true;
  });

  useEffect(() => {

    // defaultMenuSource.current = defaultMenu;
    setImportTemplate({
      allUploaded: false,
      header: [],
      model: [],
      modelInGroup: [],
      dimensionSet: []
    });

    if (settingSaveTimeout.current)
      clearTimeout(settingSaveTimeout.current);

    if (showGrid)
      setShowGrid(false);
    setTimeout(() => {
      setShowGrid(true);
    }, 160);

  }, [history.location.pathname])

  const isHelpOpen = !!helpConfig;

  const criteriaUserFieldConfig = {
    controltypeno: "TXT",
    fieldid: "approvalusername",
    fieldlabel: "username",
    helpobjectno: "HELP_SAUS",
    helpwhere: "",
    fieldwidth: 25,
  } as IFieldConfig;


  const newDocument = () => {
    const objectId = activeTabObject?.tabKey as string;

    dispatch(closeHelp({ objectId }));
    if (helpConfig?.forceOpen) {
      dispatch(changeObjectActivity({ objectId, activity: EActivity.None }));
      setTimeout(() => {
        dispatch(changeObjectActivity({ objectId, activity: EActivity.Create }));
      }, 100);
    }
    else {
      dispatch(changeObjectActivity({ objectId, activity: EActivity.Create }));
    }
  };

  const baseCloseTab = () => {
    if (activeTabObject)
      dispatch(closeTab(activeTabObject.tabKey));
  }


  // #region Grid View

  const handleFilterModalOpen = () => {
    toggleFilterModalOpen(true);
  }

  const handleFilterModalClose = () => {
    toggleFilterModalOpen(false);
  }

  const handleFilterSaveModal = () => {

    const setting = JSON.parse(JSON.stringify(activeObjectData.appliedDocumentHelpView.setting));
    delete setting.pageIndex;

    const object = {
      processcode: activeObjectData.processcode,
      filterstxt: gridViewModelValue.filterName,
      isdefault: gridViewModelValue.isDefault,
      filtersetting: JSON.stringify(setting)
    };

    dispatch(saveUserDocumentHelpFilter(object));

    setGridViewModalValues({
      filterName: "",
      isDefault: false
    });
    toggleFilterModalOpen(false);
  }

  const handleColumnVisibilityModalClose = () => {
    toggleModalColumnVisibility(false);
    closeColumnSetting();
  }

  // #endregion

  const onChangeHandler = (e: any) => {
    switch (e.target.id) {
      case "filterName":
        setGridViewModalValues(x => ({
          ...x,
          filterName: e.target.value
        }));
        break;
      case "isDefault":
        setGridViewModalValues(x => ({
          ...x,
          isDefault: e.target.value == "on"
        }));
        break;
    }
  }

  const deleteRecord = async () => {
    try {
      const Dockey = activeRow[activeObjectData.dockey];
      let message;
      if (Dockey)
        message = `You want to delete ${Dockey} entry`;
      else
        message = "You want to delete this entry";

      const res = await openErrorConfirmation({ title: "Are you sure?", text: message, confirmButtonText: "Yes, delete it!" });
      const prid = activeRow.prid as number;

      if (res.confirm && helpConfig) {
        dispatch(deleteDocument({ processcode: activeObjectData.processcode, prid }, {
          success: () => {
            reloadData();
          }
        }));
      }

    }
    catch (ex) {
      dispatch(setTabMessage({ error: ex }))
    }
  }

  const openRecord = async (row: any) => {
    try {
      var prid = row.prid as number;
      if (prid) {
        const processcode = activeTabObject?.tabActualKey as string;

        // TODO Change Function Name
        dispatch(getDocumentByPrid({ processcode: processcode, prid: prid }));

      }
      else {
        throw Error("Document Technical ID is not available");
      }

    }
    catch (ex) {
      console.error(ex);
    }
  }

  const copyDocument = async () => {
    try {
      const prid = activeRow.prid as number;
      if (prid) {
        // TODO Change Function Name
        dispatch(copyDocumentByPrid({ prid: prid }));

      }
      else {
        throw Error("Document Technical ID is not available");
      }

    }
    catch (ex) {
      console.error(ex);
    }
  }


  const openDocumentation = (url: string) => {
    window.open(url, '_blank');
  }

  const printReport = (reportno: string) => {
    const dockey = activeObjectData.dockey;
    const dockeyValue = activeRow[dockey];
    dispatch(getReportConfig({ reportObjectno: reportno, criteria: { [dockey]: dockeyValue } }));
  }

  const openInNewTab = () => {
    const dockey = activeObjectData.dockey;
    const processcode = activeObjectData.processcode;
    const dockeyValue = activeRow[dockey];
    dispatch(getScreenConfig({ processCode: processcode, transactionNo: dockeyValue }));
  }

  const openHyperLink = (processcode: string, transactionNo: string) => {
    dispatch(getScreenConfig({ processCode: processcode, transactionNo: transactionNo }));
  }

  const removeView = (prid: number) => {
    dispatch(removeUserDocumentHelp({ prid }));
  }

  const setViewDefault = (prid: number, isDefault: boolean) => {
    dispatch(setViewDefaultUserDocumentHelp({ prid, processcode: activeTabObject?.tabActualKey as string, isDefault }));
  }

  const filterByApprover = (apply: boolean) => {
    dispatch(setDocumentHelpView({ objectId: activeObjectData.objectId, documentGridViewSetting: { filterApproval: apply } }));
    dispatch(loadHelpData({ objectId: activeObjectData.objectId, filter: { filterApproval: apply } }));
  }

  const reloadData = () => {
    dispatch(loadHelpData({ objectId: activeObjectData.objectId, filter: {} }));
  }

  const initializeGrid = (GridControl: any, FilterControl: any) => {

    GridControl.allowPinning = "ColumnRange";

    setTimeout(() => {
      applyGridSetting(activeObjectData.appliedDocumentHelpView.setting);
    }, 0);

    GridControl.pinnedColumn.addHandler((s: any, e: any) => {
      storeGridSetting();
    });

    GridControl.resizedColumn.addHandler((s: any, e: any) => {
      storeGridSetting();
    });

    GridControl.draggedColumn.addHandler((s: any, e: any) => {
      storeGridSetting();
    });

    //#region Grid Events

    GridControl.hostElement.addEventListener("mouseover", (ev: any) => {
      let ht = GridControl.hitTest(ev), row = ht.getRow();
      var checkCell = wjCore.closest(ev.target, ".wj-cells");

      // show the menu for the current column
      if (GridControl.selection.col > -1 && ht.row != -1) {
        ev.preventDefault(); // cancel the browser's default menu
        if (checkCell) {
          // var rowMenu = document.getElementById("rowMenu");
          const cellElement = ht.target.closest(".wj-cell");
          if (rowMenu.current && cellElement) {
            let row = GridControl.rows[ht.row].dataItem;
            setActiveRow(row)

            const deleteRights = activeObjectData.isdeleteRights;
            if (deleteRights) {

              if (row.isreverse != undefined) {
                if (row.isreverse) {
                  showDeleteBtn(false)
                }
                else if (!row.isreverse) {
                  showDeleteBtn(true)
                }
              }
              else {
                showDeleteBtn(true)
              }
            }
            else {
              showDeleteBtn(false)
            }

            setShowMenu(true)

            rowMenu.current.style.top = `${cellElement.getBoundingClientRect().top}px`;
          }
        }
      }
    });

    GridControl.hostElement.addEventListener("mouseout", (ev: any) => {

      if (!rowMenu.current?.contains(ev.relatedTarget)) {
        setShowMenu(false)
      }
    });

    GridControl.hostElement.addEventListener("click", (ev: any) => {
      let ht = GridControl.hitTest(ev);
      if (ht.row != -1) {
        let row = GridControl.rows[ht.row].dataItem;
        var col = GridControl.columns[ht.col];
        var colConfig = helpConfig?.helpConfig.Header.find(x => x.ColumnID == col.binding);
        var checkCell = wjCore.closest(ev.target, ".wj-cells");

        if (GridControl.selection.col > -1 && ht.target.closest("#dockey")) {
          let row = GridControl.rows[ht.row].dataItem;
          openRecord(row);
        }
        if (ht.target.classList.value.includes("jumpto-link")) {
          var hyperlinkjump = colConfig?.hyperlinktransactioncode as string;
          var transactionNo = row[col.binding];
          if (transactionNo)
            openHyperLink(hyperlinkjump, transactionNo)
        }
      }
    });

    GridControl.formatItem.addHandler(function (s: any, e: any) {
      var col = s.columns[e.col];
      var colConfig = helpConfig?.helpConfig.Header.find(x => x.ColumnID == col.binding);

      if (!col)
        return;

      if (e.panel == s.cells) {
        const docKey = activeObjectData.dockey;
        const isDockey = col.binding == docKey;
        // var gridConfig = activeObject.ScreenConfig.Grids
        if (isDockey) {
          e.cell.setAttribute("role", "button");
          e.cell.innerHTML = `<span class="grid-hyperlink document-link" role="button">${e.cell.innerHTML}</span>`
          e.cell.id = "dockey"
        }
        else if (colConfig?.hyperlinktransactioncode && !isDockey) {
          e.cell.innerHTML = `<span class="grid-hyperlink jumpto-link" role="button">${e.cell.innerHTML}</span>`;
        }
      }
    });

    //#endregion

    configureGridOption(GridControl);
  }

  const applyGridSetting = (view: IDocumentHelpView["setting"]) => {
    const GridControl = gridRef.current?.gridRef.current.control;
    if (GridControl) {
      const gridSearchRef = gridRef.current?.gridSearchRef.current.control;
      const gridView = view;

      gridView.orderBy.map(x => {
        const isAscending = x.direction.toLowerCase() == "asc";
        GridControl.collectionView.sortDescriptions.push(new wijmo.SortDescription(x.columnId, isAscending));
      });

      const filterCon = gridRef.current?.gridFilterRef.current?.control;
      filterCon.clear();

      gridView.filterCondition.map(x => {

        if (x.active1 || x.active2) {
          const filter = filterCon.getColumnFilter(x.columnId);

          filter.conditionFilter.column.binding = x.columnId;
          filter.conditionFilter.condition1.operator = x.operator1 == -1 ? null : x.operator1;
          filter.conditionFilter.condition1.value = x.value1;
          filter.conditionFilter.and = x.and;
          filter.conditionFilter.condition2.operator = x.operator2 == -1 ? null : x.operator2
          filter.conditionFilter.condition2.value = x.value2;
        }

      });

      filterCon.apply();

      const userColumnIndex = gridView.columnIndex;

      let index = 0;
      userColumnIndex.map(x => {
        const column = GridControl.columns.getColumn(x);
        if (column) {
          GridControl.columns.moveElement(column.index, index);
          column.width = gridView.columnWidth[index];

          const hidden = gridView.columnHidden.find(x => x == column.binding);
          if (hidden)
            column.visible = false;
          else
            column.visible = true;

          //* this is important work don't remove it without understanding
          index++;
        }
      });

      gridSearchRef.text = gridView.wholeSearchValue;
      gridRef.current?.setPaging?.((x) => ({
        ...x,
        pageSize: gridView.pageSize
      }))

      GridControl.frozenColumns = gridView.frozenColumns
    }
  }

  const storeGridSetting = () => {

    if (settingSaveTimeout.current)
      clearTimeout(settingSaveTimeout.current);

    settingSaveTimeout.current = setTimeout(() => {
      const filtersetting = {
        frozenColumns: gridRef.current?.gridRef.current.control.frozenColumns,
        columnIndex: gridRef.current?.gridRef.current.control.columns.map((x: any) => x.binding),
        columnWidth: gridRef.current?.gridRef.current.control.columns.map((x: any) => x.width),
        columnHidden: gridRef.current?.gridRef.current.control.columns.filter((x: any) => !x.visible).map((x: any) => x.binding)
      }

      dispatch(setDocumentHelpView({ objectId: activeObjectData.objectId, documentGridViewSetting: filtersetting }));
    }, 500);
  }

  const applyView = (viewSetting: IOtherState["userDocumentHelpFilter"][0]) => {
    const filterPrid = viewSetting.prid;
    const setting = JSON.parse(viewSetting.filtersetting) as IDocumentHelpView["setting"];

    if (helpConfig?.helpConfig?.Config?.serverpaging) {
      dispatch(loadHelpData({ objectId: activeObjectData.objectId, filter: setting }, {
        helpLoaded: () => {
          dispatch(setDocumentHelpView({ objectId: activeObjectData.objectId, filterPrid, documentGridViewSetting: setting }));
          applyGridSetting(setting);
        }
      }));
    }
    else {
      dispatch(setDocumentHelpView({ objectId: activeObjectData.objectId, filterPrid, documentGridViewSetting: setting }));
      applyGridSetting(setting);
    }

  }

  const clearView = () => {
    if (helpConfig) {
      const setting: IDocumentHelpView["setting"] = {
        columnHidden: ["prid"],
        columnIndex: helpConfig.helpConfig.Header.map(x => x.ColumnID),
        columnWidth: helpConfig.helpConfig.Header.map(x => 180/*x.ColumnWidth*/),
        frozenColumns: 0,
        filterApproval: false,
        filterCondition: [],
        orderBy: [],
        pageIndex: 0,
        pageSize: 25,
        wholeSearchValue: "",
        wholeSearchParameter: []
      };

      const view = {
        filtersetting: JSON.stringify(setting),
        prid: 0
      } as IOtherState["userDocumentHelpFilter"][0];

      applyView(view);
    }
  }

  const DocumentHelpBeforeCollectionViewInitialize = (option: KeyValueObject) => {
    option.pageSize = activeObjectData.appliedDocumentHelpView.setting.pageSize;
    if (activeObjectData.appliedDocumentHelpView.setting.pageIndex != undefined)
      option.pageIndex = activeObjectData.appliedDocumentHelpView.setting.pageIndex;
  }

  const onDocumentHelpPageChange = (pageSize: number, pageIndex: number) => {
    dispatch(setDocumentHelpView({ objectId: activeTabObject?.tabKey as string, documentGridViewSetting: { pageSize, pageIndex } }));
  }

  const onDocumentHelpSortColumn = (orderBy: KeyValueObject) => {
    dispatch(setDocumentHelpView({ objectId: activeTabObject?.tabKey as string, documentGridViewSetting: { orderBy: [orderBy as IDocumentHelpView["setting"]["orderBy"][0]] } }));
  }

  const onDocumentHelpFilterApplied = (filterObject: KeyValueObject) => {
    dispatch(setDocumentHelpView({ objectId: activeTabObject?.tabKey as string, documentGridViewSetting: { pageIndex: 0, filterCondition: [filterObject as IDocumentHelpView["setting"]["filterCondition"][0]] } }));
  }

  const onDocumentHelpWholeSearchChange = (value: string, searchParameters: KeyValueObject) => {
    dispatch(setDocumentHelpView({ objectId: activeTabObject?.tabKey as string, documentGridViewSetting: { pageIndex: 0, wholeSearchValue: value, wholeSearchParameter: searchParameters as any } }));
  }


  // #region Grid Column Visibility

  const clearAll = () => {
    setObjects(objects.map(x => ({ ...x, selected: false })));
  }

  const selectAll = () => {
    setObjects(objects.map(x => ({ ...x, selected: true })));
  }

  const configureGridOption = (GridControl: any) => {
    if (helpConfig) {
      var updatedObjects: any = [];

      helpConfig.helpConfig.Header.map((x) => {

        const object: any = {
          header: x.ColumnText,
          columnId: x.ColumnID,
          selected: GridControl.columns.getColumn(x.ColumnID).visible,
        }

        updatedObjects.push(object);
      });

      setObjects(updatedObjects);
    }
  }

  // Column Visibility check / uncheck
  const updateObject = (columnId: string) => {
    const updatedObjects = objects.map((object) => {
      if (object.columnId == columnId) {
        object.selected = !object.selected;
      }

      return object;
    })
    setObjects(updatedObjects)
  }

  const closeColumnSetting = () => {
    document.getElementById("grid-menu-column")?.click();
    document.getElementById("grid-menu-button")?.click();

    configureGridOption(gridRef.current?.gridRef.current.control);
  }

  const saveColumnVisibilitySetting = () => {
    gridRef.current?.gridRef.current.control.columns.forEach((column: any) => {
      const gridColumnObject: any = objects.find(x => x.columnId == column.binding);

      if (gridColumnObject) {
        if (column.visible != gridColumnObject?.selected) {
          column.visible = gridColumnObject?.selected;
        }
      }
    });

    storeGridSetting();
    configureGridOption(gridRef.current?.gridRef.current.control);
  }

  // #endregion

  // #region Template Upload / Download

  const handleImportModalClose = async () => {
    if (importTemplate.allUploaded == false && importTemplate.model.length) {
      const res = await openConfirmation({ title: "Are you sure, you want to close Uploader?", text: "" });
      if (res.cancel)
        return;
    }

    toggleImportModalOpen(false);

    if (importTemplate.model.filter(x => x._isuploaded).length && helpConfig)
      reloadData();

    setImportTemplate({
      allUploaded: false,
      header: [],
      model: [],
      modelInGroup: [],
      dimensionSet: []
    });
  }

  const downloadScreenUploadingTemplate = async () => {
    try {
      const processcode = activeObjectData.processcode as string;
      const importLabel = activeObjectData.importlabelstxt as string;

      const importTemplate = await getScreenUploadingTemplateFunc(processcode);

      if (importTemplate.length) {

        const templateData: ArrayKeyValueObject = [];

        importTemplate.filter(x => !x.ColumnID.isEqual("_uploadingresponse", "_isuploaded", "_row_id", "_transactionno")).map((x) => {
          const cellInfo: KeyValueObject = { v: x.ColumnID, t: "s" };
          if (x.mandatory)
            cellInfo.s = {
              border: {
                top: { style: "thin", color: { rgb: "FF0000" } },
                bottom: { style: "thin", color: { rgb: "FF0000" } },
                right: { style: "thin", color: { rgb: "FF0000" } },
                left: { style: "thin", color: { rgb: "FF0000" } }
              }
            };

          templateData.push(cellInfo);
        });

        var workbook = XLSX.utils.book_new();
        var worksheet = XLSX.utils.aoa_to_sheet([templateData]);

        XLSX.utils.book_append_sheet(workbook, worksheet, 'Export')
        XLSX.writeFile(workbook, `${importLabel} Template.xlsx`);

      }
      else {
        throw Error("No Template Found");
      }
    }
    catch (error) {
      dispatch(setTabMessage({ tabId: activeObjectData.objectId, error }));
    }
  }

  const getScreenUploadingTemplateFunc = async (processcode: string) => {
    try {
      let importTemplate: typeof importHeaderTemplate = importHeaderTemplate;
      if (!importTemplate.length) {
        dispatch(toggleLoader(true));
        const importTemplateConfig = await requestGetScreenUploadingTemplate(processcode);

        importTemplate.push({
          ColumnID: "_uploadingresponse",
          ColumnText: "Uploading Response",
          ColumnWidth: 0,
          controltype: "text",
          hyperlinktransactioncode: "",
          ishidden: false,
          mandatory: false,
          fielddataformatno: ""
        });
        importTemplate.push({
          ColumnID: "_isuploaded",
          ColumnText: "Uploaded",
          ColumnWidth: 0,
          controltype: "checkbox",
          hyperlinktransactioncode: "",
          ishidden: true,
          mandatory: false,
          fielddataformatno: ""
        });
        importTemplate.push({
          ColumnID: "_row_id",
          ColumnText: "_row_id",
          ColumnWidth: 0,
          controltype: "text",
          hyperlinktransactioncode: "",
          ishidden: true,
          mandatory: false,
          fielddataformatno: ""
        });
        importTemplate.push({
          ColumnID: "_transactionno",
          ColumnText: "Transaction no",
          ColumnWidth: 0,
          controltype: "text",
          hyperlinktransactioncode: "",
          ishidden: false,
          mandatory: false,
          fielddataformatno: ""
        });

        importTemplateConfig.map((x: any) => {
          let heading = x.objectno;
          let controltype = "";
          let mandatory = false;
          if (x.gridno) {
            heading = (x.gridno as string).getCollectionNameFromGridno() + "/" + heading;

            const gridFieldObject = activeObjectData.GridConfig[x.gridno]?.Header?.find(y => y.fieldid == x.objectno);
            controltype = gridFieldObject?.controltypeno || "TXT";
            mandatory = gridFieldObject?.validatemandatory || false;
          }
          else {
            const fieldObject = activeObjectData.FieldConfig.find(y => y.fieldid == x.objectno);

            controltype = fieldObject?.controltypeno || "TXT";
            mandatory = fieldObject?.validatemandatory || false;
          }

          importTemplate.push({
            ColumnID: heading,
            ColumnText: heading,
            ColumnWidth: 0,
            controltype,
            hyperlinktransactioncode: "",
            ishidden: false,
            mandatory,
            fielddataformatno: "",
          });
        });

        setImportHeaderTemplate(importTemplate);
      }

      return importTemplate;
    }
    catch (ex) {
      throw ex;
    }
    finally {
      dispatch(toggleLoader(false));
    }
  }

  const readDataFromExcelAndPreview = async (e: any) => {

    try {
      const fileData: any = await BaseMethods.readFileAsync(e);
      e.target.value = null;
      const processcode = activeObjectData.processcode as string;

      var input = new Uint8Array(fileData);
      var workbook = XLSX.read(input, { type: "array", cellDates: true });

      var worksheet = workbook.Sheets[workbook.SheetNames[0]];
      const data: ArrayKeyValueObject = XLSX.utils.sheet_to_json(worksheet);

      // #region Date converting Funcations

      const getTimezoneOffsetMS = (date: Date) => {
        var time = date.getTime();
        var utcTime = Date.UTC(date.getFullYear(),
          date.getMonth(),
          date.getDate(),
          date.getHours(),
          date.getMinutes(),
          date.getSeconds(),
          date.getMilliseconds());
        return time - utcTime;
      }

      const importBugHotfixDiff = (function () {
        const basedate = new Date(1899, 11, 30, 0, 0, 0);
        const dnthreshAsIs = (new Date().getTimezoneOffset() - basedate.getTimezoneOffset()) * 60000;
        const dnthreshToBe = getTimezoneOffsetMS(new Date()) - getTimezoneOffsetMS(basedate);
        return dnthreshAsIs - dnthreshToBe;
      }());

      const fixPrecisionLoss = (date: Date) => {
        return (new Date(date.getTime() - importBugHotfixDiff));
      }

      data.map((arr) => {
        Object.entries(arr).map(([key, value]) => {
          if (value instanceof Date) {
            arr[key] = fixPrecisionLoss(value);
          }
        })
      });
      //#endregion

      if (data.length) {

        const importTemplate = await getScreenUploadingTemplateFunc(processcode);
        toggleImportModalOpen(true);

        const modelInGroup: ArrayKeyValueObject = [];
        const dimensionSet: IDimension[] = [];

        const groupingColumns: any[] = [];

        importTemplate.map((x) => {
          if (!x.ColumnID.includes("/") || x.ColumnID.startsWith("dimensionset/")) {
            groupingColumns.push(x.ColumnID);
          }
        });

        const dataWithGroup = data.groupBy(...groupingColumns);

        let indexOnGroup = 0;
        Object.entries(dataWithGroup).map(([key, value]) => {
          const model: KeyValueObject = {
            legalentityno: selectedLegalEntity
          };
          indexOnGroup++;

          value.map((x, i) => {

            x["_row_id"] = indexOnGroup;
            x["_isuploaded"] = false;
            x["_uploadingresponse"] = "";
            x["_transactionno"] = "";

            var dimensionObject: KeyValueObject = {};

            Object.keys(x).filter(y => y.includes("dimensionset/")).sort().map(key => {
              const code = key.substring(0, key.lastIndexOf('/'));
              const fieldid = key.substring(key.lastIndexOf('/') + 1);

              if (x[key]?.trim()) {
                if (!dimensionObject[code])
                  dimensionObject[code] = {};
                dimensionObject[code][fieldid] = x[key].trim();
              }
              delete x[key];
            });

            Object.entries(dimensionObject).map(([key, value]) => {

              var md5_code = md5(JSON.stringify(value).toLowerCase()).toLowerCase();
              if (!dimensionSet.find(x => x.dimensionSet == md5_code)) {
                dimensionSet.push({
                  dimensionSet: md5_code,
                  dimensionValues: value,
                  dimensionRelations: [],
                  isDraftDimension: false
                });
              }

              x[key] = md5_code;
              x[key.replace("dimensionset", "dimensionaccountnovalues")] = Object.keys(value).map(x => value[x]).join("-");

            });

            var keys = Object.keys(x);

            keys.map(headerFielid => {

              // Grid Fields
              if (headerFielid.includes("/")) {
                const gridid = headerFielid.split("/")[0];
                const fieldid = headerFielid.split("/")[1];

                if (!model[gridid])
                  model[gridid] = [];

                if (!model[gridid][i])
                  model[gridid].push({ lineid: i + 1 });

                if (fieldid != "lineid")
                  model[gridid][i][fieldid] = x[headerFielid];
              }
              // Header Normal Fields
              else {
                model[headerFielid] = x[headerFielid];
              }
            });

          });

          modelInGroup.push(model);
        });

        setImportTemplate({
          allUploaded: false,
          header: importTemplate,
          model: data,
          modelInGroup: modelInGroup,
          dimensionSet: dimensionSet
        });

      }
      else {
        throw Error("There is no data in Excel Template");
      }

    }
    catch (error) {
      dispatch(setTabMessage({ tabId: activeObjectData.objectId, error }));
    }
  }

  const uploadScreenDataFromTemplateFunc = async () => {
    try {
      dispatch(toggleLoader(true));
      dispatch(loaderText("The task is being executed, Please wait until it is completed."));

      const processcode = activeObjectData.processcode as string;

      const model = importTemplate.modelInGroup.filter(x => importTemplate.model.findIndex(y => y._row_id == x._row_id && y._isuploaded == false) != -1);

      const saveOption: ISaveParams = {
        documentReleased: true,
        requestForApproval: activeObjectData.hasCreateApproval
      };

      const response: ArrayKeyValueObject = await requestUploadScreenDataFromTemplate(processcode, model, importTemplate.dimensionSet, saveOption);

      const previousModel = importTemplate.model.cloneArray();
      response.map((x: any) => {
        previousModel.map(y => {
          if (y._row_id == x.row_id) {
            if (x.Error)
              y._uploadingresponse = x.Error.Message;
            else {
              y._uploadingresponse = "Uploaded";
              y._transactionno = x.DocKeyValue;
              y._isuploaded = true;
            }
          }
        });
      });
      const allUploaded = previousModel.length == previousModel.filter(x => x._isuploaded).length;

      setImportTemplate(previousState => ({ ...previousState, model: previousModel, allUploaded }));

    }
    catch (error) {
      dispatch(setTabMessage({ tabId: activeObjectData.objectId, error }));
    }
    finally {
      dispatch(toggleLoader(false));
    }
  }

  const downloadUploadingRemain = () => {

    const importLabel = activeObjectData.importlabelstxt as string;

    const data = importTemplate.model.filter(y => y._isuploaded == false).cloneArray().map(x => {

      delete x._isuploaded;
      delete x._row_id;

      return x;
    });

    var workbook = XLSX.utils.book_new();
    var worksheet = XLSX.utils.json_to_sheet(data);

    XLSX.utils.book_append_sheet(workbook, worksheet, 'Export')
    XLSX.writeFile(workbook, `${importLabel} Template.xlsx`);

  }

  // #endregion


  // favorite
  const BaseSetUserFavorite = (objectcontrollerno: string, objectcontrollerstxt: string, applicationobjecttype: string) => {
    dispatch(setUserFavorite({ objectcontrollerno, objectcontrollerstxt, applicationobjecttype }))
  }

  if (isHelpOpen && helpConfig && helpConfig.helpOpenFor.isEqual(EHelpOpenFor.Document)) {
    const hasApproval = activeObjectData.hasChangeApproval || activeObjectData.hasCreateApproval || activeObjectData.hasDeleteApproval || activeObjectData.hasReverseApproval;

    return (
      <>

        <input ref={importFileRef} onChange={(e) => readDataFromExcelAndPreview(e)} type="file" style={{ display: "none" }} />

        <Modal
          heading="Column Visibility"
          show={columnVisibilityModalState}
          close={handleColumnVisibilityModalClose}
          modalSize="sm"
          bodyStyle={{ maxHeight: "500px", overflow: "auto" }}
          footer={
            <>
              <Button variant="primary" onClick={saveColumnVisibilitySetting}>
                Save
              </Button>
            </>
          }
        >
          <>
            <div className="d-flex align-items-center">
              <FormControl id="search" value={objectSearch} type="text" placeholder="Search" onChange={(e: any) => setObjectSearch(e.target.value)} />
              <OverlayTrigger placement="bottom" overlay={<Tooltip>Select All</Tooltip>}>
                <Button variant="icon-light" className="ms-2" onClick={selectAll}>
                  <BiSelectMultiple size="14" />
                </Button>
              </OverlayTrigger>
              <OverlayTrigger placement="bottom" overlay={<Tooltip>Clear All</Tooltip>}>
                <Button variant="icon-light" className="ms-2" onClick={clearAll}>
                  <MdOutlineCancel size="14" />
                </Button>
              </OverlayTrigger>
            </div>
            <hr />
            {
              filterObjects.map((object: any) =>
                <Dropdown.ItemText key={object.columnId}>
                  <div className="d-flex">
                    <p>{object.header}:</p>
                    <Form.Check
                      className="ms-auto"
                      type="switch"
                      onClick={(ev: any) => { updateObject(object.columnId) }}
                      checked={object.selected}
                      readOnly />
                  </div>
                </Dropdown.ItemText>
              )
            }
          </>
        </Modal>

        {/* View Saving */}
        <Modal
          heading="Add Applied View +"
          show={filterModalOpen}
          close={handleFilterModalClose}
          modalSize="sm"
          footer={
            <>
              <Button variant="light" onClick={handleFilterModalClose}>
                <IoMdClose className="me-2" size="14" />
                Close
              </Button>
              <Button variant="primary" onClick={handleFilterSaveModal}>
                <IoMdSave className="me-2" size="14" />
                Save
              </Button>
            </>
          }
        >
          <Form>
            <Form.Group className="mb-3">
              <Form.Control id="filterName" value={gridViewModelValue.filterName} onChange={onChangeHandler} type="text" placeholder="View Name" />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Check id="isDefault" checked={gridViewModelValue.isDefault} onChange={onChangeHandler} type="checkbox" label="Default" />
            </Form.Group>
          </Form>
        </Modal>

        {/* Import Modal */}
        <Modal
          heading={`Import ${activeObjectData.importlabelstxt}`}
          show={importModalOpen}
          close={handleImportModalClose}
          modalSize="xl"
          footer={
            <>
              <Button variant="light" onClick={handleImportModalClose}>
                <IoMdClose className="me-2" size="14" />
                Close
              </Button>
              <Button disabled={!importTemplate.model.length || importTemplate.allUploaded} variant="light" onClick={uploadScreenDataFromTemplateFunc}>
                <IoMdSave className="me-2" size="14" />
                Upload
              </Button>
            </>
          }
        >
          <>
            <div className="d-flex">
              <Button variant="light" onClick={() => importFileRef.current?.click()}>
                <FiUpload className="me-2" size="14" />
                Re-Import File
              </Button>
              {
                importTemplate.model.filter(x => x._isuploaded == true).length && !importTemplate.allUploaded ?
                  <Button className="ms-2" variant="light" onClick={downloadUploadingRemain}>
                    <FiDownload className="me-2" size="14" />
                    Download Remain
                  </Button>
                  : null
              }

            </div>

            {
              importTemplate.header.length ?
                <TableHelpUI
                  id={activeTabObject?.tabKey + "_uploader" as string}
                  helpType={EHelpType.Normal}
                  columns={importTemplate.header}
                  data={importTemplate.model}
                  multiSelect={false}
                  paging={false}
                />
                : null
            }
          </>
        </Modal>

        <div id="document-help-container">
          <div className="document-help-header">
            {
              activeObjectData.processcodestxt
            }
            <OverlayTrigger placement="bottom" overlay={<Tooltip><ControlTranslation system={true} controlId="lbladdtofavorite" /></Tooltip>}>
              <div className="favorite" onClick={() => BaseSetUserFavorite(activeObjectData.processcode, activeObjectData.processcodestxt, activeObjectData.applicationobjecttype)}>
                {
                  activeObjectData.isfavorite ? (
                    <AiFillStar size="24" />
                  ) : (
                    <AiOutlineStar size="24" />
                  )
                }
              </div>
            </OverlayTrigger>
          </div>
          <div className="document-help-grid">
            {/* <div ref={rowMenu} className={classNames(["grid-row-menu", { "show": showMenu }])}>
              <div className="grid-row-controls">
                {
                  !activeObjectData.savemode.isEqual("L") && activeObjectData.iscreate && activeObjectData.clonerequired ? (
                    <OverlayTrigger placement="bottom" overlay={<Tooltip>Copy Document</Tooltip>}>
                      <FiCopy color="#007db8" size="14" onClick={copyDocument} />
                    </OverlayTrigger>
                  ) : null
                }

                {
                  activeObject.ScreenConfig.ProcessReports.length >= 1 ? (
                    <OverlayTrigger placement="bottom" overlay={<Tooltip>Print {defaultReport?.reportstxt}</Tooltip>}>
                      <HiOutlinePrinter color="#007db8" size="14" onClick={() => printReport(defaultReport?.reportno as string)} />
                    </OverlayTrigger>
                  ) : null
                }

                {
                  deleteBtn ?
                    <OverlayTrigger placement="bottom" overlay={<Tooltip>Delete Document</Tooltip>}>
                      <IoMdTrash color="#007db8" size="14" onClick={deleteRecord} />
                    </OverlayTrigger>
                    : null
                }

                <OverlayTrigger placement="bottom" overlay={<Tooltip>Open in New Tab</Tooltip>}>
                  <Icon icon="ExternalLink" color="#007db8" size="14" onClick={openInNewTab} />
                </OverlayTrigger>
              </div>
            </div> */}
            <div className="action-bar">
              {/* <Button variant="danger" onClick={baseCloseTab}>
                <IoMdClose className="me-2" size="14" />
                <ControlTranslation system={true} controlId="btnclose" />
              </Button> */}
              <OverlayTrigger placement="bottom" overlay={<Tooltip><ControlTranslation system={true} controlId="btnapplyfilter" /></Tooltip>}>
                <DropdownButton variant="light" className={classNames(["ms-2 lg-menu", { "active": activeObjectData.appliedDocumentHelpView.filterPrid != 0 }])} title={<FiFilter size="14" className="me-1" />}>
                  {
                    activeObjectData.userDocumentHelpFilter.map((x, i) => (
                      <Dropdown.Item className={classNames([{ active: x.prid == activeObjectData.appliedDocumentHelpView.filterPrid }])} key={x.prid} role="button">
                        <div className="d-flex">
                          <Form.Check type="checkbox" data-rh={x.isdefault ? "Remove from Default" : "Mark as Default"} checked={x.isdefault} onChange={() => setViewDefault(x.prid, !x.isdefault)} />
                          <div className="ms-3 w-100" onClick={() => applyView(x)}>
                            {x.filterstxt}
                            {
                              x.isdefault ?
                                <>
                                  <br />
                                  <small><em className="font-weight-light">Default</em></small>
                                </>
                                : null
                            }
                          </div>
                          <span onClick={() => removeView(x.prid)}>
                            <IoMdTrash size="14" />
                          </span>
                        </div>
                      </Dropdown.Item>
                    ))
                  }
                  {
                    activeObjectData.userDocumentHelpFilter.length >= 1 ?
                      <Dropdown.Divider />
                      : null
                  }
                  <Dropdown.Item role="button" className="text-center" onClick={handleFilterModalOpen}>Add Applied View +</Dropdown.Item>
                </DropdownButton>
              </OverlayTrigger>

              <OverlayTrigger placement="bottom" overlay={<Tooltip><ControlTranslation system={true} controlId="btnrefresh" /></Tooltip>}>
                <Button variant="light" className="ms-2" onClick={() => reloadData()}>
                  <IoMdRefresh size="14" />
                </Button>
              </OverlayTrigger>

              {
                hasApproval ?
                  <Button variant="light" className={classNames(["ms-2", { "active": activeObjectData.appliedDocumentHelpView.setting.filterApproval }])} onClick={() => filterByApprover(!activeObjectData.appliedDocumentHelpView.setting.filterApproval)}>
                    <FaRegCheckCircle className="me-2" size="14" />
                    <ControlTranslation system={true} controlId="btnmyapproval" />
                  </Button>
                  : null
              }

              {
                activeObjectData.DocumentationUrls.length == 1 ? (
                  <OverlayTrigger placement="bottom" overlay={<Tooltip>Screen Documentation</Tooltip>}>
                    <Button
                      className="ms-2"
                      variant="light"
                      onClick={() => openDocumentation(activeObjectData.DocumentationUrls[0].documenturl)}
                    >
                      <GrInfo size="14" />
                    </Button>
                  </OverlayTrigger>
                ) : (activeObjectData.DocumentationUrls.length > 1 ? (
                  <OverlayTrigger placement="bottom" overlay={<Tooltip>Screen Documentation</Tooltip>}>
                    <DropdownButton
                      variant="light"
                      as={ButtonGroup}
                      className="menu-w-100 ms-2 "
                      title={<GrInfo size="14" />}
                    >
                      {
                        activeObjectData.DocumentationUrls.map((x, i) => {
                          return (
                            <Dropdown.Item key={x.documentstxt} onClick={() => openDocumentation(x.documenturl)}>
                              {x.documentstxt}
                            </Dropdown.Item>
                          )
                        })
                      }
                    </DropdownButton>
                  </OverlayTrigger>
                ) : null)
              }

              {
                helpConfig.helpConfig ? (
                  <>
                    <Workspace objectType="E" />
                  </>
                )
                  : null
              }

              <div className="ms-auto">
                {
                  activeObjectData.allowimport ?
                    <>
                      <OverlayTrigger placement="bottom" overlay={<Tooltip>{activeObjectData.importlabelstxt} <ControlTranslation system={true} controlId="lblforupload" /></Tooltip>}>
                        <Button variant="outline-primary" className="me-2" onClick={() => downloadScreenUploadingTemplate()}>
                          <FiDownload size="14" />
                        </Button>
                      </OverlayTrigger>

                      <OverlayTrigger placement="bottom" overlay={<Tooltip><ControlTranslation system={true} controlId="lblupload" /></Tooltip>}>
                        <Button variant="outline-primary" className="me-2" onClick={() => importFileRef.current?.click()}>
                          <FiUpload size="14" />
                        </Button>
                      </OverlayTrigger>
                    </>
                    : null
                }
                {
                  activeObjectData.iscreateRights ?
                    <Button variant="primary" onClick={newDocument}>
                      <ControlTranslation system={true} controlId="btnnew" />
                      <IoMdAdd size="14" className="ms-2" />
                    </Button>
                    : null
                }
              </div>
            </div>


            <div className="grid-btn-group">
              <Dropdown id="grid-menu" className="caret-none" autoClose={false}>
                <OverlayTrigger placement="bottom" overlay={<Tooltip>Grid Menu</Tooltip>}>
                  <Dropdown.Toggle id="grid-menu-button" variant="white" className="p-0">
                    <BsThreeDotsVertical size="14" />
                  </Dropdown.Toggle>
                </OverlayTrigger>

                <Dropdown.Menu>
                  <Dropdown.Item onClick={() => { toggleModalColumnVisibility(true) }}>Column Visibility</Dropdown.Item>
                  <Dropdown.Item onClick={clearView}>Clear View</Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>

            </div>

            {
              showGrid ?
                <TableHelpUI
                  id={activeTabObject?.tabKey as string}
                  initializeGrid={initializeGrid}
                  columns={helpConfig.helpConfig.Header}
                  data={helpConfig.helpConfig.Detail}
                  totalRowsCount={helpConfig.helpConfig.RecordsTotal}
                  filteredRowsCount={helpConfig.helpConfig.RecordsFiltered}
                  serverPaging={helpConfig.helpConfig.Config.serverpaging}
                  beforeCollectionViewInitialize={DocumentHelpBeforeCollectionViewInitialize}
                  changePage={onDocumentHelpPageChange}
                  sortColumn={onDocumentHelpSortColumn}
                  filterApplied={onDocumentHelpFilterApplied}
                  wholeSearchChange={onDocumentHelpWholeSearchChange}
                  // rowSelect={singleRowSelect}
                  multiSelect={false}
                  modalStyle={{ height: "calc(100% - 51px)" }}
                  helpType={helpConfig.helpType}
                  extraParam={{ hasApproval }}
                  ref={gridRef}
                />
                : null
            }

          </div>
        </div>
      </>
    );
  }
  else return null;
};

export default DocumentHelpUI;
